<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        รายชื่อแพทย์
      </h3>
      <v-row class="mx-1 my-2 mt-8">
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          class="card-search mb-5 pa-2"
        >
          <v-text-field
            v-model="search"
            class="card-search"
            label="ค้นหา"
            dense
            solo
            hide-details
            append-icon="mdi-magnify"
            clearable
            color="#00A99D"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          sm="12"
          md="2"
          lg="2"
          xl="2"
          class="pa-2 pr-0"
          v-if="role == 'admin'"
        >
          <v-btn
            class="card-medium"
            color="#00a99d"
            dark
            block
            @click="dialog_add = true"
            ><v-icon class="mr-2">mdi-plus-circle</v-icon>เพิ่มบุคลากร</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="role == 'admin'">
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 50%"
          class="pt-0 pr-0"
          v-for="(item, index) in roleList"
          :key="index"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="filterRole(index)"
            :color="filter_role == index ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row no-gutters>
              <v-col col col-12 class="d-flex align-center justify-start">
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      class="font-18 font-weight-bold"
                      :style="`color: ${
                        filter_role == index ? '#FFFFFF' : '#00a99d'
                      };`"
                    >
                      {{ item.number }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      class="font-18"
                      :style="`color: ${
                        filter_role == index ? '#FFFFFF' : '#00a99d'
                      };`"
                    >
                      {{ item.title }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="docterList"
        :footer-props="{
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        hide-default-footer
        :loading="loadingTable"
        loading-text="กำลังโหลดข้อมูล"
        v-if="role != 'admin' || (role == 'admin' && filter_role == 0)"
      >
        <template v-slot:no-data>
          <span class="font-14">ไม่มีข้อมูล</span>
        </template>

        <template v-slot:progress>
          <v-progress-linear
            indeterminate
            height="3px"
            color="#00A99D"
            class="mx-0"
          ></v-progress-linear>
        </template>

        <template v-slot:item.no="{ item }">
          <span class="font-16">
            {{
              page > 1
                ? (page - 1) * 10 + docterList.indexOf(item) + 1
                : docterList.indexOf(item) + 1
            }}
          </span>
        </template>

        <template v-slot:item.name="{ item }"
          ><span class="font-16">{{
            item.fullname != " " ? item.fullname : "-"
          }}</span>
        </template>

        <template v-slot:item.department="{ item }">
          <span class="font-16">{{ item.department || "-" }}</span>
        </template>

        <template v-slot:item.imgMed="{ item }">
          <v-avatar v-if="item.gender == 'หญิง'" size="70" class="ma-2">
            <v-img :src="require('@/assets/img/doctor.png')"></v-img>
          </v-avatar>
          <v-avatar v-else size="70" class="ma-2">
            <v-img :src="require('@/assets/img/doctor2.png')"></v-img>
          </v-avatar>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status == false"
            color="#fbe9e8"
            class="red--text chip-border"
            ><v-icon color="red" class="mr-2">mdi-circle-medium</v-icon>
            <span class="font-16">ไม่ว่าง</span>
          </v-chip>
          <v-chip v-else color="#d5f7db" class="chip-border"
            ><v-icon color="#1CCE39" class="mr-2">mdi-circle-medium</v-icon>
            <span style="color: #1cce39" class="font-16">ว่าง</span>
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
            bottom
            origin="center center"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                :disabled="!item.status"
                @click="openConference(item)"
                fab
                class="mx-1"
                elevation="1"
              >
                <v-icon color="#00a99d" size="36">mdi-video-plus</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </template>
      </v-data-table>
      <v-data-table
        :headers="headers_nurse"
        :items="docterList"
        :footer-props="{
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        hide-default-footer
        :loading="loadingTable"
        loading-text="กำลังโหลดข้อมูล"
        v-else
      >
        <template v-slot:no-data>
          <span class="font-14">ไม่มีข้อมูล</span>
        </template>

        <template v-slot:progress>
          <v-progress-linear
            indeterminate
            height="3px"
            color="#00A99D"
            class="mx-0"
          ></v-progress-linear>
        </template>

        <template v-slot:item.no="{ item }">
          <span class="font-16">
            {{
              page > 1
                ? (page - 1) * 10 + docterList.indexOf(item) + 1
                : docterList.indexOf(item) + 1
            }}
          </span>
        </template>

        <template v-slot:item.name="{ item }">
          <span class="font-16">{{
            item.fullname != " " ? item.fullname : "-"
          }}</span>
        </template>

        <template v-slot:item.imgMed="{ item }">
          <v-avatar v-if="item.gender == 'หญิง'" size="70" class="ma-2">
            <v-img :src="require('@/assets/img/doctor.png')"></v-img>
          </v-avatar>
          <v-avatar v-else size="70" class="ma-2">
            <v-img :src="require('@/assets/img/doctor2.png')"></v-img>
          </v-avatar>
        </template>
      </v-data-table>
      <Pagination :totals="total" :isPage="page" @page="changePage" />

      <!-- <pre>{{ docterList }}</pre> -->
      <v-dialog v-model="dialog" width="600" persistent scrollable>
        <v-form>
          <v-card tile>
            <v-card-title
              ><span
                class="pl-3"
                style="font-size: 20px; color: #00a99d; font-weight: bold"
                >ค้นหารายชื่อผู้ป่วย</span
              ></v-card-title
            >
            <v-card-text>
              <v-col cols="12" class="pb-4">
                <v-autocomplete
                  v-model="patient"
                  no-filter
                  :items="[...patientList]"
                  return-object
                  solo
                  hide-details
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                  @keyup="searchData"
                  color="#00a99d"
                  item-color="teal darken-2"
                  clearable
                  @click:clear="(search = ''), searchData()"
                  ><template v-slot:append>
                    <v-btn text icon>
                      <v-icon color="#00A99D">mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <template slot="label">
                    <span class="text-a5a5a5 font-14"
                      >ค้นหารายชื่อผู้ป่วย (ก่อนทำการวิดีโอคอล)</span
                    >
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template slot="selection" slot-scope="{ item }">
                    <span>{{ item.text }}</span>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <div class="d-flex flex-column">
                      <span>{{ item.text }}</span>
                    </div>
                  </template></v-autocomplete
                >
              </v-col>

              <v-card-actions class="pa-0">
                <v-col cols="6">
                  <v-btn block outlined color="red" @click="close()"
                    >ยกเลิก</v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    :disabled="!patient || !patient.value"
                    color="#00a99d"
                    style="color: white"
                    @click="save()"
                    ><v-icon class="mr-2 text-white">mdi-video-plus</v-icon
                    >วิดีโอคอล</v-btn
                  >
                </v-col>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="dialog_add" width="600">
        <v-form ref="form_add" v-model="valid" lazy-validation>
          <v-card tile>
            <v-card-title
              ><span style="font-size: 20px; color: #00a99d; font-weight: bold">
                เพิ่มรายชื่อบุคคลากร
              </span>
              <v-spacer></v-spacer>
              <v-icon @click="close_add()" color="#00a99d">mdi-close</v-icon>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6">
                  <span style="font-size: 16px; color: black"> ชื่อ : </span>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                  <v-text-field
                    color="#00a99d"
                    placeholder="ชื่อ (ภาษาไทย)"
                    solo
                    hide-details="auto"
                    dense
                    :readonly="view"
                    v-model="item.staff_first_name_th"
                    :rules="rules.rule_name_th"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6">
                  <span style="font-size: 16px; color: black"> นามสกุล : </span>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                  <v-text-field
                    color="#00a99d"
                    placeholder="นามสกุล (ภาษาไทย)"
                    solo
                    hide-details="auto"
                    dense
                    :readonly="view"
                    v-model="item.staff_last_name_th"
                    :rules="rules.rule_lastname_th"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6">
                  <span style="font-size: 16px; color: black"> Oneid : </span>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                  <v-text-field
                    color="#00a99d"
                    placeholder="OneId"
                    solo
                    hide-details="auto"
                    dense
                    :readonly="view"
                    v-model="item.one_id"
                    :rules="rules.rule_oneid"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6">
                  <span style="font-size: 16px; color: black"> ตำแหน่ง : </span>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="6" lg="6" class="pt-0">
                  <v-select
                    solo
                    v-model="item.role"
                    :items="role_list"
                    hide-details="auto"
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                    color="#00a99d"
                    placeholder="เลือกตำแหน่ง"
                    :rules="rules.rule_role"
                    required
                    outlined
                    item-color="teal darken-2"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pa-0">
              <v-col cols="6">
                <v-btn
                  block
                  outlined
                  color="red"
                  style="border-radius: 20px 5px"
                  @click="close_add()"
                  >ยกเลิก</v-btn
                >
              </v-col>
              <v-col cols="6">
                <v-btn
                  dark
                  color="#00a99d"
                  block
                  style="border-radius: 20px 5px"
                  depressed
                  @click.prevent="addStaff()"
                  >ตกลง</v-btn
                >
              </v-col>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { Pagination } from "@/components/pagination";

export default {
  components: {
    Pagination,
  },
  data: () => ({
    search: "",
    view: false,
    btn_loading: false,

    dialog: false,
    patient: [],
    isEmptySelect: [(v) => !!v || "กรุณาเลือกข้อมูล"],
    patientList: [],
    role: sessionStorage.role_name,
    dialog_add: false,
    headers: [
      {
        text: "ลำดับ",
        value: "no",
        sortable: false,
        align: "center",
        width: "8%",
      },
      {
        text: "",
        align: "left",
        sortable: false,
        value: "imgMed",
        width: "10%",
      },
      {
        text: "ชื่อแพทย์",
        align: "center",
        sortable: false,
        value: "name",
        width: "30%",
      },
      {
        text: "แผนก",
        align: "center",
        sortable: false,
        value: "department",
        width: "15%",
      },
      {
        text: "สถานะ",
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: "จัดการ",
        value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],
    headers_nurse: [
      {
        text: "ลำดับ",
        value: "no",
        sortable: false,
        align: "center",
        width: "8%",
      },
      {
        text: "",
        align: "left",
        sortable: false,
        value: "imgMed",
        width: "10%",
      },
      {
        text: "ชื่อพยาบาล",
        align: "center",
        sortable: false,
        value: "name",
        width: "30%",
      },
      {
        text: "สถานะ",
        align: "center",
        sortable: false,
        // value: "status",
      },
      {
        text: "จัดการ",
        // value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],
    roleList: [
      {
        title: "แพทย์",
        number: 0,
        img: "@/assets/img/doctor.png",
        imgActive: "@/assets/img/doctor.png",
      },
      {
        title: "พยาบาล",
        number: 0,
        img: "@/assets/img/doctor.png",
        imgActive: "@/assets/img/doctor.png",
      },
    ],
    loadingTable: true,
    docterList: [],
    page: 1,
    select_doctor: {},
    total: 0,
    filter_role: 0,
    item: {
      one_id: "",
      staff_first_name_th: "",
      staff_last_name_th: "",
      role: "",
      biz_id: "",
    },
    role_list: ["แพทย์", "พยาบาล"],
    rules: {
      rule_name_th: [(v) => !!v || "กรุณากรอกชื่อ (ภาษาไทย)"],
      rule_lastname_th: [(v) => !!v || "กรุณากรอกนามสกุล (ภาษาไทย)"],
      rule_oneid: [(v) => !!v || "กรุณากรอก Oneid"],
      rule_role: [(v) => !!v || "กรุณาเลือกตำแหน่ง"],
    },
    valid: false,
  }),
  async created() {
    this.searchData();
    if (this.role == "admin") {
      this.getDocterListAdmin("");
    } else {
      this.getDocterList("");
    }
    localStorage.setItem("isCapture", true);
  },
  computed: {
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    search(val) {
      if (val == "" || val == null) {
        if (this.role == "admin") {
          this.getDocterListAdmin("");
        } else {
          this.getDocterList("");
        }
      } else {
        if (this.role == "admin") {
          this.getDocterListAdmin(val);
        } else {
          this.getDocterList(val);
        }
      }
    },
  },
  sockets: {
    connect() {
      console.log("connect sockets io");
    },
    staffs(res) {
      if (res) {
        if (this.role == "admin") {
          this.getDocterListAdmin("");
        } else {
          this.getDocterList("");
        }
      }
    },
  },
  methods: {
    ...mapMutations(["setDetailConference"]),
    openConference(item) {
      this.select_doctor = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.patient = [];
    },
    close_add() {
      this.dialog_add = false;
      this.item = {
        one_id: "",
        staff_first_name_th: "",
        staff_last_name_th: "",
        role: "",
        biz_id: "",
      };
      this.$refs.form_add.resetValidation();
    },
    async save() {
      try {
        const {
          patient: {
            value: {
              account_title_th,
              first_name_th,
              last_name_th,
              one_id: oneId,
              userqr_id,
            } = {},
          } = {},
          select_doctor: { one_id: doctorOneid, role: role_name } = {},
        } = this;
        const params = {
          send_by: {
            one_id: sessionStorage.account_id,
            role: sessionStorage.role_name,
          },
          receiver_by: {
            one_id: doctorOneid,
            role: role_name,
          },
          patient_id: oneId || userqr_id,
          biz_id: sessionStorage.biz_id,
        };
        const { data: { result, data } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-room-wtw`,
          params
        );
        if (result == "success") {
          this.$router.push({
            name: "ConferenceDetail",
            query: {
              token: data.sender_token,
              patient_name: `${account_title_th} ${first_name_th} ${last_name_th}`,
              conference_id: data.conference_id,
              sender: true,
            },
          });
        }
      } catch (error) {
        if (error.response.data.message == "Unable to call oneself.") {
          this.errorAlert(
            "ไม่สามารถ Conference ได้",
            "เนื่องจากท่านไม่สามารถ Conference หาตัวเองได้"
          );
        } else {
          this.errorAlert("เกิดข้อผิดพลาด", "ไม่สามารถ Conference ได้");
        }
        console.error();
      }
    },
    errorAlert(title, text) {
      this.$swal({
        position: "center",
        icon: "error",
        width: 450,
        title: title,
        text: text,
        showConfirmButton: false,
        timer: 3000,
        backdrop: false,
      });
    },
    changePage(e) {
      this.page = e;
      this.getDocterList("");
    },
    async searchData(search) {
      let word = "";
      if (search !== undefined) {
        if (search.target.value.length !== 0) {
          word = search.target.value;
        }
      }
      const params = new URLSearchParams();
      params.append("biz_id", sessionStorage.biz_id);
      params.append("search", word);
      params.append("limit", 1000);

      const { data: { data } = {} } = await this.axios.get(
        `${process.env.VUE_APP_BACKEND_URL}/v1/patients/search?${params}`
      );

      if (data[0]) {
        // const { data: dataSearch = {} } = data[0];

        // dataSearch.forEach((element, index) => {
        //   dataSearch[index].fullname = `${
        //     element.account_title_th ? element.account_title_th : ""
        //   }${element.first_name_th ? element.first_name_th : ""} ${
        //     element.last_name_th ? element.last_name_th : ""
        //   }`;
        // });
        // this.patientList = Object.assign([], dataSearch);
        // this.patientList = data[0].data
        this.patientList = [];
        data[0].data.forEach((ele) => {
          this.patientList.push({
            text: ele.first_name_th + " " + ele.last_name_th,
            mobile: ele.mobile,
            value: ele,
          });
        });
      }
    },
    async getDocterList(val) {
      try {
        this.loadingTable = true;
        this.docterList = [];

        const biz_id = sessionStorage.biz_id;
        const params = new URLSearchParams();
        params.append("page", this.page || 1);
        params.append("limit", 10);
        params.append("search", val || "");
        params.append("role", "แพทย์");

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/staffs/${biz_id}?${params}`
          )
          .then((res) => {
            if (res.data && res.data.data) {
              setTimeout(() => {
                this.loadingTable = false;
                let findDoctor = res.data.data[0].data.filter(
                  (e) => e.role == "แพทย์"
                );
                findDoctor.forEach((element) => {
                  element.fullname = `${
                    element.gender == "หญิง" ? "พญ." : "นพ."
                  }${
                    element.staff_first_name_th
                      ? element.staff_first_name_th
                      : ""
                  } ${
                    element.staff_last_name_th ? element.staff_last_name_th : ""
                  }`;
                });
                const data = Object.assign([], findDoctor);
                const filterDoctor = data.filter(item => item.one_id !== sessionStorage.oneId);
                this.docterList = filterDoctor
                this.total = res.data.data[0].metadata[0].total || 0;
                // console.log("getDocterList", res.data.data[0].metadata[0]);
              }, 1500);
            }
          });
      } catch (error) {
        console.error();
        this.loadingTable = false;
        this.docterList = [];
      }
    },
    async getDocterListAdmin(val) {
      try {
        this.loadingTable = true;
        this.docterList = [];

        const biz_id = sessionStorage.biz_id;
        const params = new URLSearchParams();
        params.append("biz_id", biz_id);
        params.append("page", this.page || 1);
        params.append("limit", 10);
        params.append("search", val || "");
        if (this.filter_role == 0) {
          params.append("role", "แพทย์");
        } else {
          params.append("role", "พยาบาล");
        }

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v2/staffs?${params}`
            // `http://localhost:5000/v2/staffs?${params}`
          )
          .then((res) => {
            if (res.data && res.data.data) {
              setTimeout(() => {
                this.loadingTable = false;
                const { data_all, count_data } = res.data.data;
                const { data, metadata } = data_all[0];
                // let findDoctor = res.data.data[0].data.filter(
                //   (e) => e.role == "แพทย์"
                // );
                data.forEach((element) => {
                  if (this.filter_role == 0) {
                    element.fullname = `${
                      element.gender == "หญิง" ? "พญ." : "นพ."
                    }${
                      element.staff_first_name_th
                        ? element.staff_first_name_th
                        : ""
                    } ${
                      element.staff_last_name_th
                        ? element.staff_last_name_th
                        : ""
                    }`;
                  } else {
                    element.fullname = `${
                      element.gender == "หญิง" ? "พยาบาล" : "บุรุษพยาบาล"
                    }${
                      element.staff_first_name_th
                        ? element.staff_first_name_th
                        : ""
                    } ${
                      element.staff_last_name_th
                        ? element.staff_last_name_th
                        : ""
                    }`;
                  }
                });
                this.roleList[0].number = count_data.find(
                  (obj) => obj._id == "แพทย์"
                ).count;
                this.roleList[1].number = count_data.find(
                  (obj) => obj._id == "พยาบาล"
                ).count;
                this.docterList = Object.assign([], data);
                this.total = metadata[0].total || 0;
                // console.log("getDocterList", res.data.data[0].metadata[0]);
              }, 1500);
            }
          });
      } catch (error) {
        console.error();
        this.loadingTable = false;
        this.docterList = [];
      }
    },
    filterRole(index) {
      this.filter_role = index;
      if (this.page == 1) {
        this.getDocterListAdmin("");
      } else {
        this.page = 1;
      }
    },
    async addStaff() {
      if (this.$refs.form_add.validate()) {
        this.item.biz_id = sessionStorage.biz_id;
        await this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/add_staff`, this.item)
          .then((res) => {
            if (res.data.result === "success") {
              this.close_add();
              if (this.role == "admin") {
                this.getDocterListAdmin("");
              } else {
                this.getDocterList("");
              }
              this.$swal.fire({
                icon: "success",
                title: `<span style="font-size: 20px;">บันทึกข้อมูลสำเร็จ</span>`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          })
          .catch((err) => {
            if (err.response.data.code == 400) {
              this.close_add();
              this.$swal.fire({
                icon: "error",
                title: `<span style="font-size: 20px;">บันทึกข้อมูลไม่สำเร็จ</span>`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          });
      }
    },
  },
};
</script>
<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-download {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}
</style>
